<template>
  <v-container class="mx-lg-6 mt-7">
    <v-row>
      <v-spacer/>
      <v-col sm="11" xl="9">
        <h1 class="mt-4">Hilfe</h1>
        <h2>
          Benutzerhandbuch zur Bestellung von Vermessungsunterlagen</h2>
        <p>
          <v-row sm="11" xl="9" class="ma-5 mt-1 ml-8">
            <v-icon
                left color="green"
                class="pb-2"
            >mdi-cloud-download
            </v-icon>
            <a target="_blank" href="/portal/VUP%20Benutzerhandbuch_offener%20Zugang.pdf"
               style="text-decoration: none">Benutzerhandbuch als PDF-Dokument herunterladen</a>
          </v-row>
        </p>
        <h2>
          Browsereinstellungen</h2>

        <ul>
          <li class="mb-3">Zur Bestellung von Vermessungsunterlagen muss im verwendeten Browser
            <strong>Javascript</strong>
            aktiviert sein, da dies zur Ausführung
            bestimmter wesentlicher Funktionen in der Portalanwendung benötigt wird.
          </li>
          <li class="mb-3">Einige Funktionen des Portals öffnen neue Browserfenster, beispielsweise zur Darstellung von
            Abfrageergebnissen.
            Ein aktivierter PopUp-Blocker (unabhängig ob browserintern oder über ein externes Programm) kann das Öffnen
            des Fensters verhindern.
            Bitte stellen Sie sicher, dass für das Portal <strong>kein PopUp-Blocker aktiviert</strong> ist.
          </li>
          <li class="mb-3">Für die fehlerfreie Nutzung des Portals muss in Ihrem Browser die Verwaltung von <strong>Cookies
            erlaubt</strong> und aktiviert sein.
          </li>
        </ul>

        <h1 style="margin-top: 60px">Kontakt Kundenbetreuung</h1>

        <p class="mt-4">
          Hier finden Sie die Ansprechpartner:innen Ihrer zuständigen Bezirksregierung – zuständig für die Nutzerverwaltung:
          <a
              @click="showContactInfo=!showContactInfo">
            <v-icon class="ml-5 mr-1 mt-n1" small
                    color="#3C506E"
            >mdi-information-outline
            </v-icon>Kontaktinformation <span v-if="!showContactInfo">einblenden</span>
          <span v-else>ausblenden</span></a>
          <v-card class="ma-4 pa-4" v-if="showContactInfo" flat>
            <table style="width:70em">
              <tbody><tr><th>Bezirksregierung</th><th>Name</th><th>Telefon</th><th>E-Mail</th></tr>
              <tr><td>Arnsberg</td><td>Thomas Gräfrath</td><td>02931/82-3408</td><td><a href="mailto:thomas.graefrath@bra.nrw.de">thomas.graefrath@bra.nrw.de</a></td></tr>
              <tr><td>Arnsberg</td><td>Sebastian Kleinsorgen</td><td>02931/82-2821</td><td><a href="mailto:sebastian.kleinsorgen@bra.nrw.de">sebastian.kleinsorgen@bra.nrw.de</a></td></tr>
              <tr><td>Detmold</td><td>Stefan Mühlenbernd</td><td>05231/71-3118</td><td><a href="mailto:stefan.muehlenbernd@bezreg-detmold.nrw.de">stefan.muehlenbernd@bezreg-detmold.nrw.de</a></td></tr>
              <tr><td>Detmold</td><td>Sabine Hornberg</td><td>05231/71-3115</td><td><a href="mailto:sabine.hornberg@bezreg-detmold.nrw.de">sabine.hornberg@bezreg-detmold.nrw.de</a></td></tr>
              <tr><td>Düsseldorf</td><td>Sebastian Rübhausen</td><td>0211/475-2743</td><td><a href="mailto:sebastian.ruebhausen@brd.nrw.de">sebastian.ruebhausen@brd.nrw.de</a></td></tr>
              <tr><td>Düsseldorf</td><td>Holger Kapfer</td><td>0211/475-2130</td><td><a href="mailto:holger.kapfer@brd.nrw.de">holger.kapfer@brd.nrw.de</a></td></tr>
              <tr><td>Köln</td><td>Ralph Greuling</td><td>0221/147-4393</td><td><a href="mailto:ralph.greuling@bezreg-koeln.nrw.de">ralph.greuling@bezreg-koeln.nrw.de</a></td></tr>
              <tr><td>Köln</td><td>Daniela Cornelius</td><td>0221/147-3776</td><td><a href="mailto:daniela.cornelius@bezreg-koeln.nrw.de">daniela.cornelius@bezreg-koeln.nrw.de</a></td></tr>
              <tr><td>Münster</td><td>Andre Runde</td><td>0251/411-3160</td><td><a href="mailto:andre.runde@bezreg-muenster.nrw.de">andre.runde@bezreg-muenster.nrw.de</a></td></tr>
              <tr><td>Münster</td><td>Andreas Schneider</td><td>0251/411-1382</td><td><a href="mailto:andreas.schneider@bezreg-muenster.nrw.de">andreas.schneider@bezreg-muenster.nrw.de</a></td></tr>
              </tbody></table>
          </v-card>
          <br>
        </p>

        <h1 style="margin-top: 30px">Kontakt</h1>

        <p class="mt-4">
          Bei fachlichen Fragen zu den zur Verfügung gestellten Produkten des Vermessungsunterlagenportal NRW wenden Sie sich bitte an das
          zuständige Katasteramt!
          <br><a
            href="https://www.tim-online.nrw.de/tim-online2/?bg=webatlas_grau&scale=1091955&center=410000,5700000&gfi=true&wms=https://www.wms.nrw.de/geobasis/wms_nw_katasterbehoerden_uebersicht?,nw_katasterbehoerden_uebersicht"
            target="_blank">Anschriften der Katasterämter in Nordrhein-Westfalen</a>
        </p>
        <p class="pt-4">
          Bei Fragen zur Nutzung des Vermessungsunterlagenportal NRW wenden Sie sich bitte an die Bezirksregierung Köln!<br>
          Bezirksregierung Köln - Geobasis NRW - Wir helfen Ihnen gerne!<br>
          +49(0)221-147-4994 · <a
            href="mailto:geobasis@bezreg-koeln.nrw.de&subject=Portal Vermessungsunterlagen NRW - Kontaktanfrage">geobasis@bezreg-koeln.nrw.de</a><br>
          telefonische Sprechzeiten: 08:30h - 15:00h (Mo - Do) · Persönliche Besuche sind nur nach vorheriger Absprache
          möglich
        </p>

      </v-col>
      <v-spacer/>
    </v-row>

  </v-container>
</template>

<script>

import VListProductInfo from "@/components/VListProductInfo.vue";

export default {

  components: {VListProductInfo},
  data() {
    return {
      showContactInfo: false,
    }
  },
  methods: {},
  mounted() {

  }
  ,


}
</script>

<style>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 4px;
}
</style>
